import { EuiFlexGroup,EuiFlexItem } from '@elastic/eui';
import { TiposContenido } from './TiposContenido';
import { TiposInforme } from './TiposInforme';


export const ContenidosPeriodo = (props: any) => {
  
    const {periodo, ejercicio, refForm, onChangeContenido, data, isUpdate} = props;

    return(
      <EuiFlexGroup>
        <EuiFlexItem>
          <TiposContenido contenidos={data} periodo={periodo} ejercicio={ejercicio} onChange={onChangeContenido}/>
        </EuiFlexItem>
        <EuiFlexItem>
          <TiposInforme periodo={periodo} ejercicio={isUpdate? ejercicio : 0}/>
        </EuiFlexItem>
      </EuiFlexGroup>
    )
};

export default ContenidosPeriodo;